<!-- 详情页 -->
<template>
  <div class="details">
    <div class="swiper">
      <van-swipe>
        <van-swipe-item v-for="(item, index) in detailData.imgs" :key="index">
          <img :src="$global.ImgUrl + item" alt=""
        /></van-swipe-item>
      </van-swipe>
      <div class="introName">
        <h2>{{ detailData.name }}</h2>
        <audio
          :src="$global.ImgUrl + detailData.audio"
          id="audioPlayer"
        ></audio>
        <div class="audio" @click="audioPlay">
          <img src="./image/icon_playbtn.svg" v-if="!playing" alt="" />
          <img src="./image/icon_pause.svg" alt="" v-else />
        </div>
      </div>
    </div>
    <div class="address">
      <div class="addressTxt">{{ detailData.address }}</div>
    </div>
    <div class="intro">
      <div class="title" v-if="detailData.languageType == 1">内容简介</div>
      <div class="title" v-if="detailData.languageType == 2">
        The Content Validity
      </div>
      <div v-html="detailData.pointInfo"></div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { poiDetailApi } from "../../request/api/index";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      detailData: [], //点位数据
      poiData: [],
      id: "",
      languageType: "",
      // 音频播放
      playing: false, //音频播放中的状态
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  // beforeRouteLeave(to, from, next) {
  //   to.meta.keepAlive = true;
  //   next(0);
  // },
  //方法集合
  //方法集合
  methods: {
    // 音频播放停止事件
    audioPlay() {
      let that = this;
      let audio = document.getElementById("audioPlayer");
      // 改变播放/暂停图片
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.play();
        that.playing = true;
      } else {
        audio.pause();
        that.playing = false;
      }
      // 监听播放完成事件
      audio.addEventListener(
        "ended",
        function () {
          that.audioEnded();
        },
        false
      );
    },
    //  播放完成时把进度调回开始的位置
    audioEnded() {
      this.playing = false;
    },
    // 切换marker音频停止事件
    changeMarkAudioPlay() {
      let audio = document.getElementById("audioPlayer");
      // 改变播放/暂停图片
      if (audio.paused) {
        return;
      } else {
        audio.pause();
        this.playing = false;
      }
    },
    //点位详情数据
    getPoiDetailData() {
      poiDetailApi({ id: this.id, languageType: this.languageType }).then(
        (res) => {
          console.log(res);
          if (res.status == "200") {
            this.detailData = res.data.data;
          }
        }
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.id = this.$route.params.pointId;
    this.languageType = this.$route.params.languageType;
    this.getPoiDetailData();
  },
};
</script>
<style lang="less">
.details {
  width: 100%;
  height: 100vh;
  position: relative;
  background: #eee;

  .swiper {
    width: 100%;
    height: 21rem;
    position: relative;
    overflow: hidden;
    .van-swipe-item {
      width: 100%;
      height: 21rem;
      display: inline-block;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .introName {
      width: 100%;
      height: 3.2rem;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      padding: 0.5rem 1rem;
      box-sizing: border-box;
      background-color: rgba(49, 161, 199, 0.7);
      h2 {
        color: #fff;
        margin: 0;
        font-weight: 500;
        line-height: 2.2rem;
      }
      .audio {
        width: 2.8rem;
        height: 2.8rem;
        border-radius: 50%;
        position: absolute;
        right: 1.5rem;
        top: 50%;
        margin-top: -1.4rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .address {
    width: 100%;
    height: 4rem;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    box-sizing: border-box;
    .address {
      width: 100%;
      text-align: center;
      line-height: 2rem;
      font-size: 1.25rem;
      font-weight: 400;
    }
  }
  .intro {
    width: 100%;
    background: #fff;
    margin-top: 0.5rem;
    padding: 0 1rem 2rem;
    .title {
      width: 100%;
      height: 4rem;
      border-bottom: 0.1rem solid #eee;
      line-height: 4rem;
      font-size: 1.6rem;
      font-weight: 600;
    }
  }
}
</style>